module.exports = __webpack_public_path__ + "static/img/Permiso(7).47c119f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(7).jpg
// module id = jJdn
// module chunks = 0